<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="(belastingBox1 === 0) && (belastingBox2 === 0) && (belastingBox3 === 0) "
                     class="custom-input-150"
                     icon="eye"
                     type="secondary">Specificatie
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="spec-ib" size="lg"
                                title="Specificatie van de gecombineerde inkomensheffing">
  <snelstart-ui-dialog-body>
    @if (dataVisible$ | async) {
      <form [formGroup]="formGroupSpecBox1">

        @if (inkomenBox1 > 0) {
          <div class="pb-1">
            <b>Belasting over het inkomen uit werk en woning</b>
          </div>

          <div>
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Box 1 - 1e schijf: {{ this.formGroupWetgeving.get("box1PercentageSchijf1")?.value | number: '1.0-2' }}%
                van
                € {{ Math.min((this.formGroupWetgeving.get('maxBox1Inkomen1eSchijf')?.value ?? 0), inkomenBox1) | number: '1.0-0' }}
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="totaalSchijf1EnSchijf2"
                  id="totaalSchijf1EnSchijf2"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          </div>

          @if (inkomenBox1 > (this.formGroupWetgeving.get('maxBox1Inkomen1eSchijf')?.value ?? 0)) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Box 1 - 2e schijf: {{ this.formGroupWetgeving.get("box1PercentageSchijf2")?.value | number: '1.0-2' }}%
                van
                € {{ this.formGroupSpecBox1.get("lengteSchijf2")?.value | number: '1.0-0' }}
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="schijf3"
                  id="schijf3"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }

          @if (inkomenBox1 > (this.formGroupWetgeving.get('maxBox1Inkomen2eSchijf')?.value ?? 0)) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Box 1 - 3e schijf: {{ this.formGroupWetgeving.get("box1PercentageSchijf3")?.value | number: '1.0-2' }}%
                van € {{ this.formGroupSpecBox1.get("lengteSchijf3")?.value | number: '1.0-0' }}
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="schijf4"
                  id="schijf4"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }

          @if (this.formGroupSpecBox1.get('tariefsaanpassingAftrekEigenWoning')?.value ?? 0 !== 0) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Tariefsaanpassing aftrekposten
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="tariefsaanpassingAftrekEigenWoning"
                  id="tariefsaanpassingAftrekEigenWoning"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }

          @if (this.formGroupSpecBox1.get('voorkomingVerrekenmethode')?.value ?? 0 !== 0) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Af: voorkoming dubbele belasting (verrekenmethode)
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="voorkomingVerrekenmethode"
                  id="voorkomingVerrekenmethode"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }

          @if (this.formGroupSpecBox1.get('voorkomingVrijstellingsmethode')?.value ?? 0 !== 0) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Af: voorkoming dubbele belasting (vrijstellingsmethode)
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="voorkomingVerrekenmethode"
                  id="voorkomingVerrekenmethode"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }

          <div class="flex-container-dialog">
            <div class="flex-item-tekst-dialog pb-2">
              Totaal belasting box 1 over € {{ inkomenBox1 | number: '1.0-0' }}
            </div>
            <div></div>
            <div>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [disabledControl]="true"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="berekendeIB"
                                                id="berekendeIB"
                                                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
          </div>
        }
      </form>

      <form [formGroup]="formGroupSpecPremies">
        @if (premieVV > 0) {
          <div class="pb-1">
            <b>Premies over het inkomen uit werk en woning</b>
          </div>

          @if ((formGroupSpecPremies.controls.premieAOW.value ?? 0) > 0) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Premie AOW: {{ this.formGroupSpecPremies.get("aowPercentage")?.value | number: '1.0-2' }}%
                van
                € {{ Math.min((this.formGroupSpecPremies.get('premieInkomenAOWenANW')?.value ?? 0), inkomenBox1) | number: '1.0-0' }}
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="premieAOW"
                  id="premieAOW"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }
          @if ((formGroupSpecPremies.controls.premieANW.value ?? 0) > 0) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Premie AOW: {{ this.formGroupSpecPremies.get("anwPercentage")?.value | number: '1.0-2' }}%
                van
                € {{ Math.min((this.formGroupSpecPremies.get('premieInkomenAOWenANW')?.value ?? 0), inkomenBox1) | number: '1.0-0' }}
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="premieANW"
                  id="premieANW"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }
          @if ((formGroupSpecPremies.controls.premieWLZ.value ?? 0) > 0) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Premie AOW: {{ this.formGroupSpecPremies.get("wlzPercentage")?.value | number: '1.0-2' }}%
                van
                € {{ Math.min((this.formGroupSpecPremies.get('premieInkomenWLZenAZVW')?.value ?? 0), inkomenBox1) | number: '1.0-0' }}
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="premieWLZ"
                  id="premieWLZ"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }
          <div class="flex-container-dialog">
            <div class="flex-item-tekst-dialog pb-2">
              Totaal premies volksverzekeringen
            </div>
            <div></div>
            <div>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [disabledControl]="true"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="premieVV"
                                                id="premieVV"
                                                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
          </div>
        }
      </form>

      <form [formGroup]="formGroupSpecBox2">
        @if (belastingBox2 > 0) {
          <div class="pb-1">
            <b>Belasting over het inkomen uit aanmerkelijk belang</b>
          </div>

          <div class="flex-container-dialog">
            <div class="flex-item-tekst-dialog pb-2">
              Box 2 - 1e schijf: {{ this.formGroupWetgeving.get("box2PercentageSchijf1")?.value | number: '1.0-2' }}%
              van
              € {{ Math.min((this.formGroupWetgeving.get('maxBox2Inkomen1eSchijf')?.value ?? 0), inkomenBox2) | number: '1.0-0' }}
            </div>
            <div></div>
            <div>
              <snelstart-ui-number-form-control
                [decimals]="0"
                [disabledControl]="true"
                align="right"
                class="custom-input-150"
                formControlName="box2EersteSchijf"
                id="box2EersteSchijf"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
          </div>

          @if (inkomenBox2 > (this.formGroupWetgeving.get('maxBox2Inkomen1eSchijf')?.value ?? 0)) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Box 2 - 2e schijf: {{ this.formGroupWetgeving.get("box1PercentageSchijf2")?.value | number: '1.0-2' }}%
                van
                € {{ this.formGroupSpecBox2.get("lengteSchijf2")?.value | number: '1.0-0' }}
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="box2TweedeSchijf"
                  id="box2TweedeSchijf"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }

          <div class="flex-container-dialog">
            <div class="flex-item-tekst-dialog pb-2">
              Totaal belasting box 2 over € {{ inkomenBox2 | number: '1.0-0' }}
            </div>
            <div></div>
            <div>
              <snelstart-ui-number-form-control [decimals]="0"
                                                [disabledControl]="true"
                                                align="right"
                                                class="custom-input-150"
                                                formControlName="berekendeIB"
                                                id="berekendeIB"
                                                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
          </div>
        }
      </form>

      <form [formGroup]="formGroupSpecBox3">
        @if (belastingBox3 > 0) {
          <div class="pb-1">
            <b>Belasting over het inkomen uit sparen en beleggen</b>
          </div>

          <div class="flex-container-dialog">
            <div class="flex-item-tekst-dialog pb-2">
              Box 3: {{ this.formGroupWetgeving.get("tariefBox3")?.value | number: '1.0-2' }}%
              van € {{ inkomenBox3 | number: '1.0-0' }}
            </div>
            <div></div>
            <div>
              <snelstart-ui-number-form-control
                [decimals]="0"
                [disabledControl]="true"
                align="right"
                class="custom-input-150"
                formControlName="box3VoorVoorkoming"
                id="box3VoorVoorkoming"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
          </div>

          @if (this.formGroupSpecBox3.get('voorkomingVerrekenmethode')?.value ?? 0 !== 0) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Af: Verrekende buitenlandse bronheffing
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="voorkomingVerrekenmethode"
                  id="voorkomingVerrekenmethode"
                  prefix="€ -"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }

          @if (this.formGroupSpecBox3.get('vrijstellingBuitenlandsVermogen')?.value ?? 0 !== 0) {
            <div class="flex-container-dialog">
              <div class="flex-item-tekst-dialog pb-2">
                Af: Voorkoming dubbele belasting (vrijstellingsmethode)
              </div>
              <div></div>
              <div>
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  [disabledControl]="true"
                  align="right"
                  class="custom-input-150"
                  formControlName="vrijstellingBuitenlandsVermogen"
                  id="vrijstellingBuitenlandsVermogen"
                  prefix="€ -"
                ></snelstart-ui-number-form-control>
              </div>
            </div>
          }

          <div class="flex-container-dialog">
            <div class="flex-item-tekst-dialog pb-2">
              Totaal belasting box 3 over € {{ inkomenBox3 | number: '1.0-0' }}
            </div>
            <div></div>
            <div>
              <snelstart-ui-number-form-control
                [decimals]="0"
                [disabledControl]="true"
                align="right"
                class="custom-input-150"
                formControlName="berekendeIB"
                id="berekendeIB"
                prefix="€"
              ></snelstart-ui-number-form-control>
            </div>
          </div>
        }
      </form>
    }
  </snelstart-ui-dialog-body>
  <snelstart-ui-dialog-buttons class="d-flex">
    <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
    <snelstart-ui-button icon="check" id="save" type="primary">
      Afsluiten
    </snelstart-ui-button>
  </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
